import { type MiddlewareFunction, redirect } from 'react-router';

import { authContext } from '@/context/AuthContext';
import { loginPathFor } from '@/lib/utils/login-redirect';
import { getAccessToken } from '@/lib/utils/tokens';

export const authMiddleware: MiddlewareFunction = async ({ request, context }) => {
	const token = getAccessToken();
	if (!token) {
		throw redirect(loginPathFor(new URL(request.url)));
	}
	context.set(authContext, {
		token,
	});
};
